import React, { useState, Fragment, useRef } from "react";
import { Field } from "formik";
import moment from "moment";
import {
  FieldButtonGroup,
  DatePicker,
  FieldDropSide,
  SliderPanel,
  FieldInput,
  FieldInputPercentage,
  AddPlans,
  CsplTable as Table,
  Link,
  FormControlSearch,
  FieldInputNumber,
  DifferentParticipantElectionTable,
  WarningModal,
} from "../../../components";
import { INVESTMENTS_BASED_ON, usDateFormat } from "../../../utils";
import { isEmpty, get, uniqBy, uniq, uniqWith, isEqual, forEach } from "lodash";
import { useDeepEffect } from "../../../abstracts";
import { Form, Button, InputGroup, Image, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { useEffect } from "react";

export const DifferentInvestmentElection = (props) => {
  const {
    fields,
    isSave,
    isEdit,
    values,
    setFieldValue,
    handleChange,
    investmentList,
    sourcesList,
    setToggle,
    toggle,
    handleSubmit,
    autoEnrollment,
    setValues,
    deleteInvestment,
    planId,
    errors,
  } = props;
  const initialRender = useRef(true);
  const [inputFields, setInputFields] = useState([{ ageFrom: "", ageTo: "" }]);
  const [dateFields, setDateFields] = useState([{ from: "", to: "" }]);
  const [retirementFields, setRetirementFields] = useState([
    { from: "", to: "" },
  ]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [filteredResponse, setFilteredResponse] = useState({});
  const [addedInvestments, setAddedInvestments] = useState(
    get(values, "autoEnrollment.savedInvestments")
  );
  const [searchString, setSearchString] = useState("");
  const saveInvestments = get(values, "autoEnrollment.savedInvestments");
  const [totalInvestments, setTotalInvestments] = useState([]);
  const [categoryIndex, setCategoryIndex] = useState();
  const [sourceIndex, setSourceIndex] = useState();
  const [Index, setIndex] = useState();
  const validationMessageForMinimumAge = (value) => {
    return value < 18 ? "PL544 : Age cannot be less than 18 years" : undefined;
  };
  const [modalVisible, setModalVisible] = useState(false);
  // useDeepEffect(()=>{
  //   setAddedInvestments(get(values,"autoEnrollment.savedInvestments"));
  //   },[get(values,"autoEnrollment.savedInvestments"), sourcesList])

  useEffect(() => {
    values.autoEnrollment.inputFields = inputFields;
  }, [inputFields]);

  useEffect(() => {
    values.autoEnrollment.dateFields = dateFields;
  }, [dateFields]);

  useEffect(() => {
    values.autoEnrollment.retirementFields = retirementFields;
  }, [retirementFields]);

  const handleAddInvestmentElection = () => {
    let tempValues = { ...values };
    tempValues["autoEnrollment"][fields.InvestmentElectionBasedOnList] = [
      //////////////
      ...get(values, `autoEnrollment.${fields.InvestmentElectionBasedOnList}`),
      {
        autoEnrollmentId: null,
        investmentBasedOn: get(
          values,
          `autoEnrollment.${fields.sameInvestmentBasedOn}`
        ),
        ageFrom: null,
        ageTo: null,
        from: null,
        to: null,
      },
    ];
    setValues(tempValues);
  };
  const handleDeleteInvestmentElection = (index) => {
    let tempValues = { ...values };
    tempValues["autoEnrollment"][fields.InvestmentElectionBasedOnList] = get(
      values,
      `autoEnrollment.${fields.InvestmentElectionBasedOnList}`
    ).filter((_, ind) => {
      if (ind === index) {
        return false;
      }
      return true;
    });
    setValues(tempValues);
    for (let i in get(values, "autoEnrollment.differentInvestmentElection")) {
      let tempValues_ = { ...values };
      tempValues_["autoEnrollment"]["differentInvestmentElection"][i] = get(
        values,
        "autoEnrollment.differentInvestmentElection"
      )[i].filter((_, ind) => {
        if (ind === index) {
          return false;
        }
        return true;
      });
      setValues(tempValues_);
    }
  };

  let ageCat = [];
  if (
    !isEmpty(
      get(values, `autoEnrollment.${fields.InvestmentElectionBasedOnList}`)
    )
  )
    get(values, `autoEnrollment.${fields.InvestmentElectionBasedOnList}`).map(
      (e, i) => {
        var c = {};
        c = null;
        if (e.ageFrom && e.ageTo && e.ageTo.toString().length >= 2) {
          c = {
            label: (
              <div className="ml-2">
                {" "}
                <div>{e.ageFrom} Years </div>{" "}
                <div className="text-secondary-scss"> to</div>{" "}
                <div>{e.ageTo} Years</div>{" "}
              </div>
            ),
            className: "column-age",
            columnName: e.ageFrom + "-" + e.ageTo,
          };
          ageCat.push(c);
        }
      }
    );
  const ageTable = [
    {
      label: "Investment",
      className: "column-investment",
      columnName: "Investment",
    },
    {
      label: "Age Group",
      className: "ageGroup",
      columnName: "ageGroup",
      isSubTable: true,
      subTable: [
        ...ageCat,
        {
          label: "Default",
          className: "column-Default",
          columnName: "Default",
        },
      ],
    },
    {
      label: "Action",
      className: "column-action",
      columnName: "Action",
    },
  ];

  const birthDateCat = [];
  if (
    !isEmpty(
      get(values, `autoEnrollment.${fields.InvestmentElectionBasedOnList}`)
    )
  )
    get(values, `autoEnrollment.${fields.InvestmentElectionBasedOnList}`).map(
      (e, i) => {
        var c = {};
        c = null;
        if (e.from && e.to) {
          c = {
            label: (
              <div className="ml-2">
                {" "}
                <div>{moment(e.from).format("MM/DD/YYYY")} </div>{" "}
                <div className="text-secondary-scss"> to</div>{" "}
                <div>{moment(e.to).format("MM/DD/YYYY")}</div>{" "}
              </div>
            ),
            className: "column-Birthdate",
            columnName:
              moment(e.from).format("MM/DD/YYYY") +
              "-" +
              moment(e.to).format("MM/DD/YYYY"),
          };
          birthDateCat.push(c);
        }
      }
    );

  const dateTable = [
    {
      label: "Investment",
      className: "column-investment",
      columnName: "Investment",
    },
    {
      label: "Birth Date Group",
      className: "birthDateGroup",
      columnName: "birthDateGroup",
      isSubTable: true,
      subTable: [
        ...birthDateCat,
        {
          label: "Default",
          className: "column-default",
          columnName: "Default",
        },
      ],
    },
    {
      label: "Action",
      className: "column-action",
      columnName: "Action",
    },
  ];

  const retirementCat = [];
  if (
    !isEmpty(
      get(values, `autoEnrollment.${fields.InvestmentElectionBasedOnList}`)
    )
  )
    get(values, `autoEnrollment.${fields.InvestmentElectionBasedOnList}`).map(
      (e, i) => {
        var c = {};
        c = null;
        if (e.from && e.to) {
          c = {
            label: (
              <div className="ml-2">
                {" "}
                <div>{moment(e.from).format("MM/DD/YYYY")} </div>{" "}
                <div className="text-secondary-scss"> to</div>{" "}
                <div>{moment(e.to).format("MM/DD/YYYY")}</div>{" "}
              </div>
            ),
            className: "column-Birthdate",
            columnName:
              moment(e.from).format("MM/DD/YYYY") +
              "-" +
              moment(e.to).format("MM/DD/YYYY"),
          };
          retirementCat.push(c);
        }
      }
    );

  const retirementTable = [
    {
      label: "Investment",
      className: "column-investment",
      columnName: "Investment",
    },
    {
      label: "Retirement Date Group",
      className: "retirementDateGroup",
      columnName: "retirementDateGroup",
      isSubTable: true,
      subTable: [
        ...retirementCat,
        {
          label: "Default",
          className: "column-default",
          columnName: "Default",
        },
      ],
    },
    {
      label: "Action",
      className: "column-action",
      columnName: "Action",
    },
  ];

  const addInvestmentsToPlan = (investment) => {
    setAddedInvestments({
      ...addedInvestments,
      [categoryIndex]: {
        ...addedInvestments[categoryIndex],
        [sourceIndex]: [
          ...(addedInvestments[categoryIndex]?.[sourceIndex] || []),
          investment,
        ],
      },
    });
  };

  const onViewButtonClick = (index, sourceind) => {
    setModalOpen(true);
    setSourceIndex(sourceind);
    setCategoryIndex(index);
  };

  const onSubmit = (savedInvestments) => {
    let tempValues = { ...values };
    tempValues["autoEnrollment"]["savedInvestments"] = {
      ...get(values, "autoEnrollment.savedInvestments", {}),
      [categoryIndex]: {
        ...get(values, `autoEnrollment.savedInvestments.${categoryIndex}`, {}),
        [sourceIndex]: savedInvestments,
      },
    };
    setValues(tempValues);
    setModalOpen(false);
  };
  const onCancel = () => {
    if (
      addedInvestments[categoryIndex]?.[sourceIndex]?.length !=
      get(
        values,
        `autoEnrollment.savedInvestments.${categoryIndex}.${sourceIndex}`,
        []
      ).length
    ) {
      setModalVisible(true);
    } else {
      setModalOpen(false);
    }
  };
  const modalOnCancel = () => {
    setAddedInvestments({
      ...addedInvestments,
      [categoryIndex]: {
        ...addedInvestments[categoryIndex],
        [sourceIndex]: saveInvestments[categoryIndex]?.[sourceIndex],
      },
    });
    setModalOpen(false);
    setModalVisible(false);
  };
  useDeepEffect(() => {
    (sourceIndex || sourceIndex == 0) &&
      setFilteredResponse({
        ...filteredResponse,
        [categoryIndex]: {
          [sourceIndex]: investmentList.filter((team) => {
            return team.investmentName
              .toLowerCase()
              .includes(searchString.toLowerCase());
          }),
        },
      });
  }, [searchString, investmentList, categoryIndex, sourceIndex]);

  const deletefunction = (name, index, sourceInd, cellIndex, sIndex) => {
    // var temp = totalInvestments.filter((e) => e.investmentName !== name);
    var temp = saveInvestments[index]?.[sourceInd].filter(
      (e) => e.investmentName !== name
    );
    // setTotalInvestments(temp);
    setAddedInvestments({
      ...addedInvestments,
      [index]: { [sourceInd]: temp },
    });
    let tempValues = { ...values };
    tempValues["autoEnrollment"]["savedInvestments"][index][sourceInd] = temp;
    setValues(tempValues);
    for (var i = 0; i <= index; i++) {
      if (
        values.autoEnrollment.differentInvestmentElection[sourceInd] != null &&
        values.autoEnrollment.differentInvestmentElection[sourceInd][i] !=
          null &&
        values.autoEnrollment.differentInvestmentElection[sourceInd][i][
          sIndex
        ] != null
      ) {
        values.autoEnrollment.differentInvestmentElection[sourceInd][
          i
        ] = values.autoEnrollment.differentInvestmentElection[sourceInd][
          i
        ].filter((x) => x.investmentName != name);
      }
    }
  };

  const onDeleteClick = (name, index, sourceInd, cellIndex, sIndex) => {
    //setToggle(!toggle);
    // autoEnrollment.investmentDetails
    //   ? autoEnrollment.investmentDetails.forEach((e) =>
    //       e.investmentName === name
    //         ? deleteInvestment(planId, e.investmentId).then((response) => {
    //             if (response) deletefunction(name);
    //           })
    //         : deletefunction(name)
    //     )
    //   : deletefunction(name);
    deletefunction(name, index, sourceInd, cellIndex, sIndex);
  };
  const investmentListLength = (
    filteredResponse[categoryIndex]?.[sourceIndex] || []
  ).length;

  const sliderPanel = (
    <SliderPanel isOpen={isModalOpen} size="35" showCancel={false}>
      <div className="inside-content">
        <div className="d-flex justify-content-between align-baseline">
          <div>
            <p className="investment-heading">Plan Investments</p>
            <p className="investment-sub-heading">
              {investmentListLength}{" "}
              {investmentListLength === 1
                ? "Investment Available"
                : "Investments Available"}
            </p>
          </div>
          <div>
            <Button variant="secondary" onClick={() => onCancel()}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() =>
                onSubmit(addedInvestments[categoryIndex]?.[sourceIndex])
              }
              className="ml-4"
            >
              Save
            </Button>
          </div>
        </div>
        <div className="search-bar-investment">
          <Form>
            <InputGroup>
              <FormControlSearch
                size="lg"
                id="plan-search-box"
                className="plan-search-box"
                type="search"
                autoComplete="off"
                placeholder="Search Investment"
                onChange={(e) => setSearchString(e.target.value)}
              />
              {/* <InputGroup.Append>
                <InputGroup.Text className="plan-search-button">
                  <Image src="/assets/icons/svg/search.svg" width="14px" />
                </InputGroup.Text>
              </InputGroup.Append> */}
            </InputGroup>
          </Form>
        </div>
        <div className="d-flex content-end">
          <p className="investment-side-content">
            {investmentListLength}{" "}
            {investmentListLength === 1
              ? "Investment Available"
              : "Investments Available"}
          </p>
        </div>
        <div className="scroll-body">
          {filteredResponse[categoryIndex]?.[sourceIndex] &&
            (filteredResponse[categoryIndex]?.[sourceIndex] || []).map(
              (e, i) => (
                <div className="d-flex justify-content-between">
                  <p>{e.investmentName}</p>
                  {(addedInvestments[categoryIndex]?.[sourceIndex] || []).find(
                    (y) => y.investmentName === e.investmentName
                  ) ? (
                    // <Button
                    //   size="sm"
                    //   style={{ width: "75px", margin: "0px 0px 8px 0px" }}
                    //   variant="secondary"
                    //   disabled
                    //   classname="custom-added"
                    // >
                    //   Added
                    // </Button>
                    <div className="added-button-inside">
                      <div className="added-button-inner-text">Added</div>
                    </div>
                  ) : (
                    <>
                      {/* <Button
                    style={{ width: "75px", margin: "0px 0px 8px 0px" }}
                    variant="secondary"
                    onClick={() => addInvestmentsToPlan(e)}
                  >
                    Add
                  </Button> */}
                      <div
                        className="add-button-inside"
                        onClick={() => addInvestmentsToPlan(e)}
                      >
                        <div className="add-button-inner-text">Add</div>
                      </div>
                    </>
                  )}
                </div>
              )
            )}
        </div>
      </div>
    </SliderPanel>
  );

  const addInvestments = (index, sourceind) => (
    <div>
      <div className="mt-40">
        <p className="mt-20 plan-heading-plan">
          {sourcesList[sourceind].sourceName}
        </p>
        <AddPlans
          content="No Investments added."
          buttonLabel="Add Investment"
          disabled={isEdit && !isSave}
          onPrimaryClick={() => onViewButtonClick(index, sourceind)}
        />
        <p
          style={{
            display: "block",
            color: "#ff5050",
            fontSize: "0.75rem",
            marginTop: "0rem",
          }}
        >
          {get(
            errors,
            "autoEnrollment.investmentElectionDiffSourceDiffParticipant",
            ""
          )}
        </p>
      </div>
      {sliderPanel}
    </div>
  );
  const Invsum = (index, cellIndex) => {
    let sum1 = 0;
    if (
      !isEmpty(get(values, "autoEnrollment.differentInvestmentElection")) &&
      !isEmpty(
        get(values, "autoEnrollment.differentInvestmentElection")[index]
      ) &&
      !isEmpty(
        get(values, "autoEnrollment.differentInvestmentElection")[index][
          cellIndex
        ]
      )
    )
      get(values, "autoEnrollment.differentInvestmentElection")[index][
        cellIndex
      ].map((x) => (sum1 = sum1 + get(x, "investmentPercentage", 0)));
    return sum1;
  };
  const errorMsg = (invsum) =>
    invsum !== 100
      ? "The total value of investment election should not exceed or subceed 100%"
      : "";
  const AddName = (
    e,
    investmentId,
    source,
    index,
    cellIndex,
    sourceInd,
    sName,
    sourceId,
    sourceName,
    category
  ) => {
    handleChange(e);
    if (
      !isEmpty(get(values, "autoEnrollment.differentInvestmentElection")) &&
      !isEmpty(
        get(values, "autoEnrollment.differentInvestmentElection")[index]
      ) &&
      !isEmpty(
        get(values, "autoEnrollment.differentInvestmentElection")[index][
          cellIndex
        ]
      ) &&
      !isEmpty(
        get(values, "autoEnrollment.differentInvestmentElection")[index][
          cellIndex
        ][sourceInd]
      )
    ) {
      //if(!isEmpty(values.autoEnrollmentSouceInvestmentElections[index].investmentElection[ind])){
      values.autoEnrollment.differentInvestmentElection[index][cellIndex][
        sourceInd
      ].investmentName = source;
      values.autoEnrollment.differentInvestmentElection[index][cellIndex][
        sourceInd
      ].investmentId = investmentId;
      values.autoEnrollment.differentInvestmentElection[index][cellIndex][
        sourceInd
      ].sourceName = sourceName;
      values.autoEnrollment.differentInvestmentElection[index][cellIndex][
        sourceInd
      ].sourceId = sourceId;
      const x = sName.split("-");
      if (category === 1 && sName !== "Default") {
        values.autoEnrollment.differentInvestmentElection[index][cellIndex][
          sourceInd
        ].ageFrom = x[0];
        values.autoEnrollment.differentInvestmentElection[index][cellIndex][
          sourceInd
        ].ageTo = x[1];
      } else if (category === 2 && sName !== "Default") {
        values.autoEnrollment.differentInvestmentElection[index][cellIndex][
          sourceInd
        ].birthDateFrom = x[0];
        values.autoEnrollment.differentInvestmentElection[index][cellIndex][
          sourceInd
        ].birthDateTo = x[1];
      } else if (category === 3 && sName !== "Default") {
        values.autoEnrollment.differentInvestmentElection[index][cellIndex][
          sourceInd
        ].retirementDateFrom = x[0];
        values.autoEnrollment.differentInvestmentElection[index][cellIndex][
          sourceInd
        ].retirementDateTo = x[1];
      }
      values.autoEnrollment.differentInvestmentElection[index][cellIndex][
        sourceInd
      ].isDefaultCategory = sName === "Default";
      // }
    }
  };
  const investmentElectionLength = get(
    values,
    `autoEnrollment.${fields.InvestmentElectionBasedOnList}`,
    []
  ).length;
  return (
    <div>
      <Field
        size="md"
        isRequired
        name={`autoEnrollment.${fields.sameInvestmentBasedOn}`}
        label={"Investment based on"}
        options={INVESTMENTS_BASED_ON}
        value={get(values, `autoEnrollment.${fields.sameInvestmentBasedOn}`)}
        selectedValue={get(
          values,
          `autoEnrollment.${fields.sameInvestmentBasedOn}`
        )}
        onChange={(value) => {
          // setInputFields([{ ageFrom: "", ageTo: "" }]);
          // setDateFields([{ from: "", to: "" }]);
          // setRetirementFields([{ from: "", to: "" }]);
          setValues({
            ...values,
            autoEnrollment: {
              ...values.autoEnrollment,
              [fields.sameInvestmentBasedOn]: value,
              [fields.investmentBasedOn]: value,
              [fields.InvestmentElectionBasedOnList]: [
                {
                  autoEnrollmentId: null,
                  investmentBasedOn: value,
                  ageFrom: null,
                  ageTo: null,
                  from: null,
                  to: null,
                },
              ],
              differentInvestmentElection: [[[{}]]],
            },
          });
        }}
        component={FieldButtonGroup}
        //validate={required}
        disabled={isEdit && !isSave}
      />

      {get(values, `autoEnrollment.${fields.sameInvestmentBasedOn}`) === 1 ? (
        <div>
          <h5>Age</h5>
          <form>
            <div className="form-row">
              {isEmpty(
                get(
                  values,
                  `autoEnrollment.${fields.InvestmentElectionBasedOnList}`
                )
              )
                ? null
                : get(
                    values,
                    `autoEnrollment.${fields.InvestmentElectionBasedOnList}`
                  )
                    // .filter((_) => !_.isDefaultCategory)
                    .map((inputField, index) => {
                      if (inputField.isDefaultCategory) return <></>;
                      return (
                        <Row
                          style={{
                            paddingLeft: "20px",
                          }}
                        >
                          <Fragment key={`${inputField}~${index}`}>
                            <Field
                              size="xs"
                              isRequired
                              label="From"
                              name={`autoEnrollment.${[
                                fields.InvestmentElectionBasedOnList,
                              ]}.${index}.ageFrom`}
                              placeholder="Enter age"
                              component={FieldInputNumber}
                              type="number"
                              value={inputField.ageFrom}
                              onChange={handleChange}
                              disabled={isEdit && !isSave}
                              autoComplete="off"
                              max={99}
                              // validate={() =>
                              //   validationMessageForMinimumAge(
                              //     inputField.ageFrom
                              //   )
                              // }
                            />
                            <div
                              style={{
                                marginLeft: "2rem",
                              }}
                            ></div>
                            <Field
                              size="xs"
                              isRequired
                              label="To"
                              name={`autoEnrollment.${[
                                fields.InvestmentElectionBasedOnList,
                              ]}.${index}.ageTo`}
                              placeholder="Enter age"
                              component={FieldInputNumber}
                              type="number"
                              value={inputField.ageTo}
                              onChange={handleChange}
                              disabled={isEdit && !isSave}
                              autoComplete="off"
                              max={99}
                              // validate={() =>
                              //   validationMessageForMinimumAge(
                              //     inputField.ageFrom
                              //   )
                              // }
                            />
                            <div className="form-group col-sm-2 investment-basedon-icons">
                              {investmentElectionLength - 1 === index && (
                                <button
                                  className="btn btn-link"
                                  type="button"
                                  onClick={() => {
                                    handleAddInvestmentElection();
                                  }}
                                  disabled={isEdit && !isSave}
                                >
                                  +
                                </button>
                              )}
                              {index > 0 && (
                                <button
                                  className="btn btn-link"
                                  type="button"
                                  onClick={() => {
                                    if (!(isEdit && !isSave))
                                      handleDeleteInvestmentElection(index);
                                  }}
                                  disabled={isEdit && !isSave}
                                >
                                  <FontAwesomeIcon
                                    icon={faTrashAlt}
                                    color="red"
                                  />
                                </button>
                              )}
                            </div>
                          </Fragment>
                        </Row>
                      );
                    })}
            </div>
            <br />
          </form>
          <div>
            {(sourcesList || []).map((source, index) => {
              if (
                !isEmpty(saveInvestments[1]?.[index]) &&
                get(saveInvestments[1]?.[index], `0.investmentName`) != null
              ) {
                return (
                  <div>
                    <div>
                      <div className="d-flex justify-content-between align-baseline">
                        <p className="mt-20 plan-heading-plan">
                          {source.sourceName}
                        </p>
                        <Button
                          variant="secondary"
                          disabled={isEdit && !isSave}
                          onClick={() => {
                            setModalOpen(true);
                            setSourceIndex(index);
                            setCategoryIndex(1);
                          }}
                        >
                          Add Investment
                        </Button>
                      </div>
                      <div>
                        {/* <Table className="different-participants-election-table">
                          <Table.Thead>
                            <Table.Tr>
                              {ageTable.map((item, index) => {
                                return (
                                  <Table.Th
                                    key={index}
                                    className={item.className}
                                  >
                                    {item.label}
                                  </Table.Th>
                                );
                              })}
                              ;
                            </Table.Tr>
                          </Table.Thead>
                          <Table.Tbody>
                            {(saveInvestments[1]?.[index]).map(
                              (investment, sourceInd) => {
                                return (
                                  <Table.Tr key={sourceInd}>
                                    {ageTable.map((item, cellIndex) => {
                                      const fieldName = `autoEnrollment.differentInvestmentElection[${index}][${
                                        cellIndex - 1
                                      }][${sourceInd}].investmentPercentage`;
                                      const getContent = () => {
                                        if (item.columnName == "Investment") {
                                          return investment.investmentName;
                                        }
                                        if (item.columnName == "Action") {
                                          return (
                                            <Link>
                                              <FontAwesomeIcon
                                                icon={faTrashAlt}
                                                color="red"
                                                onClick={() => {
                                                  if (!(isEdit && !isSave))
                                                    onDeleteClick(
                                                      investment.investmentName,
                                                      1,
                                                      index,
                                                      cellIndex,
                                                      sourceInd
                                                    );
                                                }}
                                              />
                                            </Link>
                                          );
                                        }
                                        return (
                                          <Field
                                            size="xs"
                                            isRequired
                                            name={fieldName}
                                            hasSuggestion
                                            shouldDisplaySuggestion
                                            component={FieldInputPercentage}
                                            type="number"
                                            value={get(values, fieldName)}
                                            onChange={(e) => {
                                              handleChange(e);
                                              AddName(
                                                e,
                                                investment.investmentId,
                                                investment.investmentName,
                                                index,
                                                cellIndex - 1,
                                                sourceInd,
                                                item.label,
                                                source.sourceId,
                                                source.sourceName,
                                                1
                                              );
                                            }}
                                            disabled={isEdit && !isSave}
                                            autoComplete="off"
                                          />
                                        );
                                      };

                                      return (
                                        <Table.Td
                                          key={cellIndex}
                                          className={item.className}
                                        >
                                          {getContent()}
                                        </Table.Td>
                                      );
                                    })}
                                  </Table.Tr>
                                );
                              }
                            )}
                          </Table.Tbody>
                          <div className="line-separator-total" />
                          <Table.Tbody>
                            <Table.Tr>
                              {ageTable.map((item, cellIndex) => {
                                const getContent = () => {
                                  if (item.columnName == "Investment") {
                                    return "Total";
                                  }
                                  if (item.columnName == "Action") {
                                    return null;
                                  }
                                  return (
                                    <div>
                                      <Field
                                        size="xs"
                                        isRequired
                                        name="totalBox"
                                        hasSuggestion
                                        shouldDisplaySuggestion
                                        component={FieldInputPercentage}
                                        type="number"
                                        value={Invsum(index, cellIndex - 1)}
                                        autoComplete="off"
                                        disabled
                                        // validate={(value) => {
                                        //   return Invsum(index, cellIndex - 1) !=
                                        //     100
                                        //     ? "PL545 : The total value of investment election is not totaling to 100%"
                                        //     : undefined;
                                        // }}
                                      />
                                      <p
                                        style={{
                                          display: "block",
                                          color: "#ff5050",
                                          fontSize: "0.75rem",
                                          marginTop: "0rem",
                                          maxWidth: "130px",
                                        }}
                                      >
                                        {errorMsg(Invsum(index, cellIndex - 1))}
                                      </p>
                                    </div>
                                  );
                                };

                                return (
                                  <Table.Td
                                    key={cellIndex}
                                    className={item.className}
                                  >
                                    {getContent()}
                                  </Table.Td>
                                );
                              })}
                            </Table.Tr>
                          </Table.Tbody>
                        </Table> */}
                        <DifferentParticipantElectionTable
                          headerData={ageTable}
                          actualData={saveInvestments[1]?.[index]}
                          onDeleteClick={onDeleteClick}
                          errorMsg={errorMsg}
                          Invsum={Invsum}
                          AddName={AddName}
                          values={values}
                          isEdit={isEdit}
                          isSave={isSave}
                          index={index}
                          investmentBasedOn={1}
                          sourceId={source.sourceId}
                          sourceName={source.sourceName}
                        />
                      </div>
                    </div>
                    {sliderPanel}
                  </div>
                );
              } else {
                return addInvestments(1, index);
              }
            })}
          </div>
        </div>
      ) : null}

      {get(values, `autoEnrollment.${fields.sameInvestmentBasedOn}`) === 2 ? (
        <>
          <h5>BirthDate</h5>
          <form>
            <div className="form-row">
              {get(
                values,
                `autoEnrollment.${fields.InvestmentElectionBasedOnList}`
              ).map((inputField, index) => {
                if (inputField.isDefaultCategory) return <></>;
                return (
                  <Row
                    style={{
                      paddingLeft: "20px",
                    }}
                  >
                    <Fragment key={`${inputField}~${index}`}>
                      <Field
                        isRequired
                        label="From"
                        size="md"
                        name={`autoEnrollment.${[
                          fields.InvestmentElectionBasedOnList,
                        ]}.${index}.from`}
                        value={usDateFormat(
                          get(
                            values,
                            `autoEnrollment.${fields.InvestmentElectionBasedOnList}`
                          )[index].from
                        )}
                        placeholder="Select Birthdate"
                        isDatePicker
                        popupContent={
                          <DatePicker
                            onDayClick={(value) => {
                              let tempValues = { ...values };
                              tempValues["autoEnrollment"][
                                fields.InvestmentElectionBasedOnList
                              ][index]["from"] = value;
                              setValues(tempValues);
                            }}
                            value={usDateFormat(
                              get(
                                values,
                                `autoEnrollment.${fields.InvestmentElectionBasedOnList}`
                              )[index].from
                            )}
                          />
                        }
                        component={FieldDropSide}
                        disabled={isEdit && !isSave}
                        onClear={() =>
                          setFieldValue(
                            `autoEnrollment.${[
                              fields.InvestmentElectionBasedOnList,
                            ]}.${index}.from`,
                            null
                          )
                        }
                      />
                      <div
                        style={{
                          marginLeft: "2rem",
                        }}
                      ></div>
                      <Field
                        isRequired
                        label="To"
                        size="md"
                        name={`autoEnrollment.${[
                          fields.InvestmentElectionBasedOnList,
                        ]}.${index}.to`}
                        value={usDateFormat(
                          get(
                            values,
                            `autoEnrollment.${fields.InvestmentElectionBasedOnList}`
                          )[index].to
                        )}
                        placeholder="Select Birthdate"
                        isDatePicker
                        popupContent={
                          <DatePicker
                            onDayClick={(value) => {
                              let tempValues = { ...values };
                              tempValues["autoEnrollment"][
                                fields.InvestmentElectionBasedOnList
                              ][index]["to"] = value;
                              setValues(tempValues);
                            }}
                            value={usDateFormat(
                              get(
                                values,
                                `autoEnrollment.${fields.InvestmentElectionBasedOnList}`
                              )[index].to
                            )}
                          />
                        }
                        component={FieldDropSide}
                        disabled={isEdit && !isSave}
                        onClear={() =>
                          setFieldValue(
                            `autoEnrollment.${[
                              fields.InvestmentElectionBasedOnList,
                            ]}.${index}.to`,
                            null
                          )
                        }
                      />
                      <div className="form-group  investment-basedon-icons">
                        {investmentElectionLength - 1 === index && (
                          <button
                            className="btn btn-link"
                            type="button"
                            onClick={() => handleAddInvestmentElection()}
                            disabled={isEdit && !isSave}
                          >
                            +
                          </button>
                        )}
                        {index !== 0 && (
                          <button
                            className="btn btn-link"
                            type="button"
                            onClick={() => {
                              if (!(isEdit && !isSave))
                                handleDeleteInvestmentElection(index);
                            }}
                            disabled={isEdit && !isSave}
                          >
                            <FontAwesomeIcon icon={faTrashAlt} color="red" />
                          </button>
                        )}
                      </div>
                    </Fragment>
                  </Row>
                );
              })}
            </div>
            <br />
          </form>

          <div>
            {(sourcesList || []).map((source, index) => {
              if (
                !isEmpty(saveInvestments[2]?.[index]) &&
                saveInvestments[2]?.[index][0].investmentName != null
              ) {
                return (
                  <div>
                    <div>
                      <div className="d-flex justify-content-between align-baseline">
                        <p className="mt-20 plan-heading-plan">
                          {source.sourceName}
                        </p>
                        <Button
                          variant="secondary"
                          disabled={isEdit && !isSave}
                          onClick={() => {
                            setModalOpen(true);
                            setSourceIndex(index);
                            setCategoryIndex(2);
                          }}
                        >
                          Add Investment
                        </Button>
                      </div>
                      <div>
                        {/* <Table className="different-participants-election-table">
                          <Table.Thead>
                            <Table.Tr>
                              {dateTable.map((item, index) => {
                                return (
                                  <Table.Th
                                    key={index}
                                    className={item.className}
                                  >
                                    {item.label}
                                  </Table.Th>
                                );
                              })}
                            </Table.Tr>
                          </Table.Thead>
                          <Table.Tbody>
                            {(saveInvestments[2]?.[index]).map(
                              (investment, sourceInd) => {
                                return (
                                  <Table.Tr key={sourceInd}>
                                    {dateTable.map((item, cellIndex) => {
                                      const fieldName = `autoEnrollment.differentInvestmentElection[${index}][${
                                        cellIndex - 1
                                      }][${sourceInd}].investmentPercentage`;
                                      // "2" +
                                      // index +
                                      // "ID" +
                                      // cellIndex +
                                      // investment.investmentName;
                                      const getContent = () => {
                                        if (item.columnName == "Investment") {
                                          return investment.investmentName;
                                        }
                                        if (item.columnName == "Action") {
                                          return (
                                            <Link>
                                              <FontAwesomeIcon
                                                icon={faTrashAlt}
                                                color="red"
                                                onClick={() => {
                                                  if (!(isEdit && !isSave))
                                                    onDeleteClick(
                                                      investment.investmentName,
                                                      2,
                                                      index,
                                                      cellIndex,
                                                      sourceInd
                                                    );
                                                }}
                                              />
                                            </Link>
                                          );
                                        }
                                        return (
                                          <Field
                                            size="xs"
                                            isRequired
                                            name={fieldName}
                                            hasSuggestion
                                            shouldDisplaySuggestion
                                            component={FieldInputPercentage}
                                            type="number"
                                            value={get(values, fieldName)}
                                            onChange={(e) => {
                                              handleChange(e);
                                              AddName(
                                                e,
                                                investment.investmentId,
                                                investment.investmentName,
                                                index,
                                                cellIndex - 1,
                                                sourceInd,
                                                item.label,
                                                source.sourceId,
                                                source.sourceName,
                                                2
                                              );
                                            }}
                                            disabled={isEdit && !isSave}
                                            autoComplete="off"
                                          />
                                        );
                                      };

                                      return (
                                        <Table.Td
                                          key={cellIndex}
                                          className={item.className}
                                        >
                                          {getContent()}
                                        </Table.Td>
                                      );
                                    })}
                                  </Table.Tr>
                                );
                              }
                            )}
                          </Table.Tbody>
                          <div className="line-separator-total" />
                          <Table.Tbody>
                            <Table.Tr>
                              {dateTable.map((item, cellIndex) => {
                                const getContent = () => {
                                  if (item.columnName == "Investment") {
                                    return "Total";
                                  }
                                  if (item.columnName == "Action") {
                                    return null;
                                  }
                                  return (
                                    <div>
                                      <Field
                                        size="xs"
                                        isRequired
                                        name="totalBox"
                                        hasSuggestion
                                        shouldDisplaySuggestion
                                        component={FieldInputPercentage}
                                        type="number"
                                        value={Invsum(index, cellIndex - 1)}
                                        autoComplete="off"
                                        disabled
                                        // validate={(value) => {
                                        //   return Invsum(index, cellIndex - 1) !=
                                        //     100
                                        //     ? "PL545 : The total value of investment election is not totaling to 100%"
                                        //     : undefined;
                                        // }}
                                      />
                                      <p
                                        style={{
                                          display: "block",
                                          color: "#ff5050",
                                          fontSize: "0.75rem",
                                          marginTop: "0rem",
                                          maxWidth: "130px",
                                        }}
                                      >
                                        {errorMsg(Invsum(index, cellIndex - 1))}
                                      </p>
                                    </div>
                                  );
                                };

                                return (
                                  <Table.Td
                                    key={cellIndex}
                                    className={item.className}
                                  >
                                    {getContent()}
                                  </Table.Td>
                                );
                              })}
                            </Table.Tr>
                          </Table.Tbody>
                        </Table> */}
                        <DifferentParticipantElectionTable
                          headerData={dateTable}
                          actualData={saveInvestments[2]?.[index]}
                          onDeleteClick={onDeleteClick}
                          errorMsg={errorMsg}
                          Invsum={Invsum}
                          AddName={AddName}
                          values={values}
                          isEdit={isEdit}
                          isSave={isSave}
                          index={index}
                          investmentBasedOn={2}
                          sourceId={source.sourceId}
                          sourceName={source.sourceName}
                        />
                      </div>
                    </div>
                    {sliderPanel}
                  </div>
                );
              } else {
                return addInvestments(2, index);
              }
            })}
          </div>
        </>
      ) : null}

      {get(values, `autoEnrollment.${fields.sameInvestmentBasedOn}`) === 3 ? (
        <>
          <h5>Retirement Date</h5>
          <form>
            <div className="form-row">
              {get(
                values,
                `autoEnrollment.${fields.InvestmentElectionBasedOnList}`
              ).map((inputField, index) => {
                if (inputField.isDefaultCategory) return <></>;

                return (
                  <Row
                    style={{
                      paddingLeft: "20px",
                    }}
                  >
                    <Fragment key={`${inputField}~${index}`}>
                      <Field
                        isRequired
                        label="From"
                        size="md"
                        name={`autoEnrollment.${[
                          fields.InvestmentElectionBasedOnList,
                        ]}.${index}.from`}
                        value={usDateFormat(
                          get(
                            values,
                            `autoEnrollment.${fields.InvestmentElectionBasedOnList}`
                          )[index].from
                        )}
                        placeholder="Select Birthdate"
                        isDatePicker
                        popupContent={
                          <DatePicker
                            onDayClick={(value) => {
                              let tempValues = { ...values };
                              tempValues["autoEnrollment"][
                                fields.InvestmentElectionBasedOnList
                              ][index]["from"] = value;
                              setValues(tempValues);
                            }}
                            value={usDateFormat(
                              get(
                                values,
                                `autoEnrollment.${fields.InvestmentElectionBasedOnList}`
                              )[index].from
                            )}
                          />
                        }
                        component={FieldDropSide}
                        disabled={isEdit && !isSave}
                        onClear={() =>
                          setFieldValue(
                            `autoEnrollment.${[
                              fields.InvestmentElectionBasedOnList,
                            ]}.${index}.from`,
                            null
                          )
                        }
                      />
                      <div
                        style={{
                          marginLeft: "2rem",
                        }}
                      ></div>
                      <Field
                        isRequired
                        label="To"
                        size="md"
                        name={`autoEnrollment.${[
                          fields.InvestmentElectionBasedOnList,
                        ]}.${index}.to`}
                        value={usDateFormat(
                          get(
                            values,
                            `autoEnrollment.${fields.InvestmentElectionBasedOnList}`
                          )[index].to
                        )}
                        placeholder="Select Birthdate"
                        isDatePicker
                        popupContent={
                          <DatePicker
                            onDayClick={(value) => {
                              let tempValues = { ...values };
                              tempValues["autoEnrollment"][
                                fields.InvestmentElectionBasedOnList
                              ][index]["to"] = value;
                              setValues(tempValues);
                            }}
                            value={usDateFormat(
                              get(
                                values,
                                `autoEnrollment.${fields.InvestmentElectionBasedOnList}`
                              )[index].to
                            )}
                          />
                        }
                        component={FieldDropSide}
                        disabled={isEdit && !isSave}
                        onClear={() =>
                          setFieldValue(
                            `autoEnrollment.${[
                              fields.InvestmentElectionBasedOnList,
                            ]}.${index}.to`,
                            null
                          )
                        }
                      />
                      <div className="form-group investment-basedon-icons">
                        {investmentElectionLength - 1 === index && (
                          <button
                            className="btn btn-link"
                            type="button"
                            onClick={() => handleAddInvestmentElection()}
                            disabled={isEdit && !isSave}
                          >
                            +
                          </button>
                        )}
                        {index !== 0 && (
                          <button
                            className="btn btn-link"
                            type="button"
                            onClick={() => {
                              if (!(isEdit && !isSave))
                                handleDeleteInvestmentElection(index);
                            }}
                            disabled={isEdit && !isSave}
                          >
                            <FontAwesomeIcon icon={faTrashAlt} color="red" />
                          </button>
                        )}
                      </div>
                    </Fragment>
                  </Row>
                );
              })}
            </div>
            <br />
          </form>

          <div>
            {(sourcesList || []).map((source, index) => {
              if (
                !isEmpty(saveInvestments[3]?.[index]) &&
                saveInvestments[3]?.[index][0].investmentName != null
              ) {
                return (
                  <div>
                    <div>
                      <div className="d-flex justify-content-between align-baseline">
                        <p className="mt-20 plan-heading-plan">
                          {source.sourceName}
                        </p>
                        <Button
                          variant="secondary"
                          disabled={isEdit && !isSave}
                          onClick={() => {
                            setModalOpen(true);
                            setSourceIndex(index);
                            setCategoryIndex(3);
                          }}
                        >
                          Add Investment
                        </Button>
                      </div>
                      <div>
                        {/* <Table className="different-participants-election-table">
                          <Table.Thead>
                            <Table.Tr>
                              {retirementTable.map((item, index) => {
                                return (
                                  <Table.Th
                                    key={index}
                                    className={item.className}
                                  >
                                    {item.label}
                                  </Table.Th>
                                );
                              })}
                            </Table.Tr>
                          </Table.Thead>
                          <Table.Tbody>
                            {(saveInvestments[3]?.[index]).map(
                              (investment, sourceInd) => {
                                return (
                                  <Table.Tr key={sourceInd}>
                                    {retirementTable.map((item, cellIndex) => {
                                      const fieldName = `autoEnrollment.differentInvestmentElection[${index}][${
                                        cellIndex - 1
                                      }][${sourceInd}].investmentPercentage`;
                                      // "3" +
                                      // index +
                                      // "ID" +
                                      // cellIndex +
                                      // investment.investmentName;
                                      const getContent = () => {
                                        if (item.columnName == "Investment") {
                                          return investment.investmentName;
                                        }
                                        if (item.columnName == "Action") {
                                          return (
                                            <Link>
                                              <FontAwesomeIcon
                                                icon={faTrashAlt}
                                                color="red"
                                                onClick={() => {
                                                  if (!(isEdit && !isSave))
                                                    onDeleteClick(
                                                      investment.investmentName,
                                                      3,
                                                      index,
                                                      cellIndex
                                                    );
                                                }}
                                              />
                                            </Link>
                                          );
                                        }
                                        return (
                                          <Field
                                            size="xs"
                                            isRequired
                                            name={fieldName}
                                            hasSuggestion
                                            shouldDisplaySuggestion
                                            component={FieldInputPercentage}
                                            type="number"
                                            value={get(values, fieldName)}
                                            onChange={(e) => {
                                              handleChange(e);
                                              AddName(
                                                e,
                                                investment.investmentId,
                                                investment.investmentName,
                                                index,
                                                cellIndex - 1,
                                                sourceInd,
                                                item.label,
                                                source.sourceId,
                                                source.sourceName,
                                                3
                                              );
                                            }}
                                            disabled={isEdit && !isSave}
                                            autoComplete="off"
                                          />
                                        );
                                      };

                                      return (
                                        <Table.Td
                                          key={cellIndex}
                                          className={item.className}
                                        >
                                          {getContent()}
                                        </Table.Td>
                                      );
                                    })}
                                  </Table.Tr>
                                );
                              }
                            )}
                          </Table.Tbody>
                          <div className="line-separator-total" />
                          <Table.Tbody>
                            <Table.Tr>
                              {retirementTable.map((item, cellIndex) => {
                                const getContent = () => {
                                  if (item.columnName == "Investment") {
                                    return "Total";
                                  }
                                  if (item.columnName == "Action") {
                                    return null;
                                  }
                                  return (
                                    <div>
                                      <Field
                                        size="xs"
                                        isRequired
                                        name="totalBox"
                                        hasSuggestion
                                        shouldDisplaySuggestion
                                        component={FieldInputPercentage}
                                        type="number"
                                        value={Invsum(index, cellIndex - 1)}
                                        autoComplete="off"
                                        disabled
                                        // validate={(value) => {
                                        //   return Invsum(index, cellIndex - 1) !=
                                        //     100
                                        //     ? "PL545 : The total value of investment election is not totaling to 100%"
                                        //     : undefined;
                                        // }}
                                      />
                                      <p
                                        style={{
                                          display: "block",
                                          color: "#ff5050",
                                          fontSize: "0.75rem",
                                          marginTop: "0rem",
                                          maxWidth: "130px",
                                        }}
                                      >
                                        {errorMsg(Invsum(index, cellIndex - 1))}
                                      </p>
                                    </div>
                                  );
                                };

                                return (
                                  <Table.Td
                                    key={cellIndex}
                                    className={item.className}
                                  >
                                    {getContent()}
                                  </Table.Td>
                                );
                              })}
                            </Table.Tr>
                          </Table.Tbody>
                        </Table> */}
                        <DifferentParticipantElectionTable
                          headerData={retirementTable}
                          actualData={saveInvestments[3]?.[index]}
                          onDeleteClick={onDeleteClick}
                          errorMsg={errorMsg}
                          Invsum={Invsum}
                          AddName={AddName}
                          values={values}
                          isEdit={isEdit}
                          isSave={isSave}
                          index={index}
                          investmentBasedOn={3}
                          sourceId={source.sourceId}
                          sourceName={source.sourceName}
                        />
                      </div>
                    </div>
                    {sliderPanel}
                  </div>
                );
              } else {
                return addInvestments(3, index);
              }
            })}
          </div>
        </>
      ) : null}
      <WarningModal show={modalVisible} onHide={() => setModalVisible(false)}>
        <div className="remove-text">
          <h4>Are you sure?</h4>
          <p>Your changes may be lost. Do you want to continue ?</p>
          <Button
            type="button"
            className="remove-btn mr-4"
            onClick={() => modalOnCancel()}
          >
            Yes
          </Button>
          <Button className="cancel-btn" onClick={() => setModalVisible(false)}>
            No
          </Button>
        </div>
      </WarningModal>
    </div>
  );
};

export default DifferentInvestmentElection;
